export const UPDATE_FILTER = 'UPDATE_FILTER';
export const updateFilter = (e) => ({
  type: UPDATE_FILTER,
  payload: e,
});
